/** @format */

const template = `
<ng-form name="{{::ctrl.name}}">
  <div class="row">
    <div class="col-md-12">
      <ng-transclude></ng-transclude>
      <sis-language-pills
        data-cy="localized-string-editor-lang"
        [scope]="ctrl.scope"
        [invalid-locales]="ctrl.invalidLangFields"
        [(selected-language)]="ctrl.selectedLocale"
        (selected-language-change)="ctrl.focusLocaleInput($event)"></sis-language-pills>

      <div class="tab-content">
        <div
          ng-repeat="locale in ctrl.supportedLocales track by $index"
          class="box focusable-element"
          name="{{::locale}}"
          id="{{::'languageInput_' + locale}}"
          ng-class="{ active: ctrl.isSelectedLocale(locale), 'has-error': ctrl.form[ctrl.name][locale].$invalid }"
          medium-editor
          ng-model-options="{ allowInvalid: true }"
          ng-change="ctrl.onChangeFunc()"
          ng-model="ctrl.ngModel.$viewValue[locale]"
          bind-options="ctrl.mediumEditorOptions"
          ng-focus="ctrl.selectLocale(locale)"
          ng-minlength="ctrl.realMinLength"
          ng-maxlength="ctrl.maxLength"
          placeholder="{{ ctrl.placeholder | translate }}"
          ng-required="!ctrl.form[ctrl.name].$pristine && ctrl.ngModel.$error.requireTranslations"
          ng-attr-contenteditable="{{!ctrl.disableEditing}}">
        </div>
        <div class="markup-indicator">
          <sis-tooltip
            tooltip-text="{{'SIS_COMPONENTS.STRING.LOCALIZED_MARKUP_STRING_EDITOR.INDICATOR_TOOLTIP' | translate}}"
            [append-to-body]="ctrl.tooltipAppendToBody"
            [tooltip-block-element]="true"
            tooltip-class="tooltip-wide">
            <sis-icon icon="editor" class="sis-tooltip-trigger-content" color="white"></sis-icon>
          </sis-tooltip>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <ul
        ng-if="!ctrl.hideErrors && ctrl.form[ctrl.name].$invalid"
        class="error-list"
        ng-messages="ctrl.form[ctrl.name].$error"
        ng-messages-multiple="true"
        role="alert">
        <li ng-message="minlength" translate translate-value-langname="{{ ctrl.errors('minlength') | localeNames | localizedStringArray }}"
          >SIS_COMPONENTS.STRING.LOCALIZED_MARKUP_STRING_EDITOR.MIN_LENGTH_BENEATH_LIMIT</li
        >
        <li ng-message="maxlength" translate translate-value-langname="{{ ctrl.errors('maxlength') | localeNames | localizedStringArray }}"
          >SIS_COMPONENTS.STRING.LOCALIZED_MARKUP_STRING_EDITOR.MAX_LENGTH_EXCEEDED</li
        >
        <li ng-message="required" translate>SIS_COMPONENTS.STRING.LOCALIZED_MARKUP_STRING_EDITOR.REQUIRED</li>
      </ul>
    </div>
  </div>
</ng-form>
`;
export default template;
